export default __webpack_public_path__ + "static/media/GAME-Currency.aa16dc32.png";